import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VehicleCargo } from 'src/app/core/interfaces/vehicle-cargo';
import { Patterns } from 'src/app/core/resources/patterns';
import { Utils } from 'src/app/core/resources/utils';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { VehiclesService } from 'src/app/modules/administration/vehicles/list-vehicles.service';
import { ManualCreationCargoService } from '../../manual-creation-cargo.service';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { VehicleMessages } from 'src/app/core/messages/vehicle-messages.enum';
import { Fmt } from 'src/app/core/messages/fmt';
import { AuthService } from 'src/app/core/services/authentication.service';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { AdminUsersService } from 'src/app/modules/administration/admin-users/admin-users.service';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { CompanyService } from 'src/app/core/services/company.service';
import { Subscription } from 'rxjs';
import { Company } from 'src/app/core/interfaces/company';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { User } from 'src/app/core/interfaces/user';
import { VehicleAssignManager } from 'src/app/core/managers/vehicle-assign.manager';
import { RequestTermsDialogComponent } from 'src/app/modules/administration/request-terms-dialog/request-terms-dialog.component';

@Component({
  selector: 'app-assign-license-plate',
  templateUrl: './assign-license-plate.component.html',
  styleUrls: ['./assign-license-plate.component.scss']
})
export class AssignLicensePlateComponent implements OnInit {
  listLicensePlate = [];
  allowCreatingWithoutTruora: boolean = false;

  constructor(
    public manualCreationCargoService: ManualCreationCargoService,
    private router: Router,
    public patterns: Patterns,
    private snackBarService: SnackBarService,
    private vehiclesService: VehiclesService,
    private authService: AuthService,
    private adminUserService: AdminUsersService,
    public utils: Utils,
    public spinner: NgxSpinnerService,
    private companyService: CompanyService,
    public matDialog: MatDialog,
    private vehicleAssignManager: VehicleAssignManager
  ) { }

  ngOnInit() {
    this.listLicensePlate = this.utils.clone(this.manualCreationCargoService.getVehiclesWithLicensePlate());
    this.infoTruora();
  }

  private infoTruora() {
    const holderCompany = this.companyService.holderCompany;
    if (holderCompany && holderCompany.companyId)
      this.allowCreatingWithoutTruora = !!(holderCompany && holderCompany.allowCreatingWithoutTruora);
  }

  getIconVehicle(vehicle: VehicleCargo) {
    return '/assets/svg/icons/icon-' + vehicle.name.toLowerCase() + '.svg';
  }

  onKeyUp($event, vehicle: VehicleCargo) {
    vehicle.licensePlate = $event.target.value;
  }

  realNextStep() {
    if (this.manualCreationCargoService.isValidLicensePlate()) {
      this.manualCreationCargoService.setVehiclesWithLicensePlate(this.listLicensePlate);
      // Load measurement
      const serviceTypeName = this.manualCreationCargoService.cargoForm.controls.cargoModel['controls'].serviceType.controls.name.value;

      if (serviceTypeName === 'Contenedor vacío con carga de compensación' || serviceTypeName === 'Contenedor vacío express' || serviceTypeName === 'Carga consolidada') {
        this.manualCreationCargoService.getComponentActive().setId(2);
        this.manualCreationCargoService.getComponentActive().getStep().setId(5);
        this.router.navigate([this.manualCreationCargoService.steps.optional.url]);
      } else {
        this.manualCreationCargoService.getComponentActive().setId(2);
        this.manualCreationCargoService.getComponentActive().getStep().setId(4);
        this.router.navigate([this.manualCreationCargoService.steps.typeMerchandise.url]);
      }
    } else {
      this.snackBarService.openSnackBar('Por favor verifica el formato de las placas', undefined, 'alert');
    }

  }

  async nextStep() {
    this.spinner.show();
    let lastTravelPointDate = new Date();
    for (const destination of this.manualCreationCargoService.cargoForm.value.cargoFeature.uploadDownload.destination) {
      const arrival = new Date(destination.downloadDate.slice(0, 10));
      if (arrival > lastTravelPointDate) lastTravelPointDate = arrival;
    }
    let validVehicles = true;
    const vehiclesAssignValidationResults = await this.vehicleAssignManager.validateVehiclesForAssign(
      this.listLicensePlate.map(vehicle => vehicle.licensePlate ? vehicle.licensePlate.trim().toUpperCase() : '')
    );
    for (let i = 0; i < vehiclesAssignValidationResults.length; i++) {
      if (!this.listLicensePlate[i].licensePlate || !this.listLicensePlate[i].licensePlate.trim()) {
        this.listLicensePlate[i].licensePlate = '';
        this.listLicensePlate[i].isOwnFleet = false;
        continue;
      }
      const { isValid, message, missingInfo, driver, licensePlate, vehicle, termsUnaccepted } = vehiclesAssignValidationResults[i];
      if (!isValid) {
        this.spinner.hide();
        validVehicles = false;
        if (termsUnaccepted) return this.openModalRequestTerms(driver);
        if (missingInfo) return this.showDialogPendingDocuments(licensePlate, missingInfo);
        return this.openModalDialogError(`Error al asignar el vehículo ${licensePlate}`, message);
      }
      this.listLicensePlate[i].licensePlate = licensePlate.toUpperCase();
      this.listLicensePlate[i].isOwnFleet = this.utils.vehicleIsOwnFleet(vehicle, this.authService.getCompanySaaSConfig());
    }

    if (validVehicles) this.realNextStep();
    this.spinner.hide();
  }

  private openModalRequestTerms(driver: User) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      name: driver.information.name,
      document: driver.information.document,
      phone: driver.phone,
      user: driver
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.matDialog.open(RequestTermsDialogComponent, dialogConfig);
  }

  private showDialogPendingDocuments(licensePlate: string, missingInfo: { missingDocuments: string[], unacceptedDocuments: string[], invalidReferences: string[] }) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { title: `Error en la Información obligatoria del Vehículo ${licensePlate}`, hideBtnConfirm: true };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data.descriptionHTML = '';
    if (missingInfo.missingDocuments.length) {
      let missingDocumentsMessage = '';
      missingInfo.missingDocuments.forEach(document => missingDocumentsMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_DOCUMENTATION_INCOMPLETE}</p><ol>${missingDocumentsMessage}</ol>`;
    }
    if (missingInfo.unacceptedDocuments.length) {
      let unacceptedDocumentsMessage = '';
      missingInfo.unacceptedDocuments.forEach(document => unacceptedDocumentsMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_DOCUMENTATION_UNACCEPTED}</p><ol>${unacceptedDocumentsMessage}</ol>`;
    }
    if (missingInfo.invalidReferences.length) {
      let invalidReferencesMessage = '';
      missingInfo.invalidReferences.forEach(document => invalidReferencesMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_REFERENCES_UNACCEPTED}</p><ol>${invalidReferencesMessage}</ol>`;
    }
    return this.matDialog.open(DialogComponent, dialogConfig);
  }

  public openModalDialogError(title: string, description?: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
      iconError: true,
      descriptionHTML: `<p class="text-center">${description}</p>`,
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  stepBack() {
    this.manualCreationCargoService.getComponentActive().setId(2);
    this.manualCreationCargoService.getComponentActive().getStep().setId(2);
    this.router.navigate([this.manualCreationCargoService.steps.quantityVehicles.url]);
  }
}
